import React, { useEffect } from 'react'
import { Redirect, useLocation } from 'react-router-dom'

import useAuth from '../../auth/useAuth'
import { CALLBACK_PATH } from '../../auth/oidc'

import AuthPage from '../Auth'
import LoaderComponent from '../../components/CommonComponents/LoaderComponent'

// Cognito returns with ?code=...&state=... (or ?error=...) when /login is the callback URL.
const isSigninCallback = (search) => {
  const params = new URLSearchParams(search)
  return params.has('state') && (params.has('code') || params.has('error'))
}

const LoginPage = () => {
  const { login, isAuthenticated, isLoading } = useAuth()
  const { pathname, search } = useLocation()
  const isCallback = pathname === CALLBACK_PATH && isSigninCallback(search)

  useEffect(() => {
    if (!isCallback && !isLoading && !isAuthenticated) {
      login({ returnTo: '/dashboard' })
    }
  }, [isCallback, isLoading, isAuthenticated]) // eslint-disable-line

  if (isCallback) {
    return <AuthPage />
  }

  if (isLoading || !isAuthenticated) {
    return <LoaderComponent />
  }

  return (
    <Redirect
      to='/dashboard'
    />
  )
}

export default LoginPage
